import Helpers from '../Helpers'
import Map, { streetLayer } from '../../modules/Map'
import XHRPromise from 'xhr-promise'
import Reveal from '../Reveal'
import GeoSearch from '../GeoSearch'

const searchControl = document.getElementsByClassName('results-aside')[0]

class ResultsLocation {
    constructor(changeEvent) {
        this.control = document.getElementsByClassName('results-aside__location')[0]
        this.regions = this.control.getElementsByClassName('location-region')
        this.rootLocationCode = this.control.querySelector('.results-aside__locations').getAttribute("data-root-location")
        // TODO: replace placeholder
        this.towns = document.getElementsByClassName('location-town')
        this.distanceControl = document.getElementsByClassName('results-aside__distance')[0]
        this.townDistance = document.getElementsByName('nlm')[0]

        this.townToggle = document.getElementsByClassName('location-towns')

        this.mapElement = document.getElementById('resultsLocationMap')
        this.map = null
        this.activeGeoFetch = -1

        this.search = document.getElementsByClassName('results-aside__location-search-input')[0]
        this.searchResults = document.getElementsByClassName('results-aside__location-search-results')[0]
        this.geoSearch = new GeoSearch(this.search, this.searchResults)

        this.events()
        this.changeEvent = changeEvent

        this.init()
    }

    events() {
        const self = this
        new Helpers(this.regions).eventListener((e) => {
            e.preventDefault()
            e.stopPropagation()

            this.search.value = ''
            this.hideLocationSearchResults()

            if (this.setRegion(e.currentTarget.getAttribute('data-value'))) {
                this.setTown('')
                self.changeEvent('region')
            } else {
                this.toggleRegionExpanders()
            }
        })

        new Helpers(this.towns).eventListener((e) => {
            e.preventDefault()
            e.stopPropagation()
            this.search.value = ''
            this.hideLocationSearchResults()
            if (this.setTown(e.currentTarget.getAttribute('data-value'))) {
                this.setRegion('')
                this.townDistance.value = this.getTownDefaultDistance().dd
                this.townDistance.dispatchEvent(new CustomEvent('sync'))
                self.changeEvent('town')
            } else {
                this.toggleRegionExpanders()
            }
        })

        new Helpers(this.townDistance).eventListener((e) => {
            self.changeEvent()
        }, 'change')

        new Helpers(this.townToggle).eventListener((e) => {
            e.stopPropagation();
            const listContainer = new Helpers(e.currentTarget).getClosest('.location-towns')
            new Helpers(listContainer).toggleAttribute('aria-show-featured-only')
        })

        this.geoSearch.on('select', (data) => {
            switch (data.type) {
                case 'Region':
                    if (this.setRegion(data.code)) {
                        this.setTown('')
                        this.toggleRegionExpanders()
                        self.changeEvent('region')
                    }
                    break

            case 'Location':
                if (this.setTown(data.code)) {
                    this.setRegion('')
                    this.toggleRegionExpanders(false, true)
                    this.townDistance.value = this.getTownDefaultDistance().dd
                    this.townDistance.dispatchEvent(new CustomEvent('sync'))
                    self.changeEvent('town')
                }
                break

                case 'Cottage':
                    window.location = data.url
                    return

                default:
                    return
            }
            this.geoSearch.setValue(data.text)
            this.geoSearch.clearResults()
        })

        new Helpers(searchControl).eventListener(() => {
            this.updateMap()
        }, 'search-map')
    }

    init() {
        this.updateMap()
    }

    getRegionCodeForUrl(url) {
        const matchingRegion = Array.from(this.regions).find(region => region.getElementsByTagName('a')[0].getAttribute('href') == url)
        if (typeof matchingRegion !== 'undefined') {
            return matchingRegion.getAttribute('data-value')
        }

        return this.rootLocationCode
    }

    getRegion() {
        try {
            return Array.from(this.regions).find(region => region.getAttribute('aria-current') === 'true').getAttribute('data-value')
        } catch (err) {
            return ''
        }
    }

    getRegionTitle() {
        try {
            return Array.from(this.regions).find(region => region.getAttribute('aria-current') === 'true').getAttribute('data-title')
        } catch (err) {
            return ''
        }
    }

    getRegionHref(page = 1) {
        if (parseInt(page, 10) === 1) {
            return Array.from(this.regions)
                .find(region => region.getAttribute('aria-current') === 'true')
                .getElementsByTagName('a')[0]
                .getAttribute('href')
        }

        return Array.from(this.regions)
            .find(region => region.getAttribute('aria-current') === 'true')
            .getElementsByTagName('a')[0]
            .getAttribute('data-hrefpage')
            .replace('[page]', page)
    }

    getRegionForFeaturedSearchLinks() {
        return document.querySelector('.results-aside__locations [aria-current="true"] a').getAttribute('data-regionOnlyUrl')
    }

    getLocationUrl(page = 1) {
        const region = this.getRegion()
        const town = this.getTown()
        if (town !== '' && (region === this.rootLocationCode || region === '')) {
            let url = `/holiday-cottages-${town}`

            if (page !== 1) {
                url += `-${page}`
            }
            url += '.html'
            return url
        }

        return Array.from(this.regions)
            .find(rgn => rgn.getAttribute('aria-current') === 'true')
            .getElementsByTagName('a')[0]
            .getAttribute('data-regionUrl')
            .replace('[page]', page)
    }

    setRegion(code) {
        const selectedRegions = Array.from(this.regions).filter(region => region.getAttribute('aria-current') === 'true')

        let changeOccured = false

        if (code === '') {
            // clear any selected region
            new Helpers(this.regions).setAttributes({ 'aria-current': false })
            new Helpers(this.regions).removeClass('highlighted')
            changeOccured = selectedRegions.length > 0
        } else {
            const matchingRegions = Array.from(this.regions).filter(region => region.getAttribute('data-value') === code)

            new Helpers(this.regions).setAttributes({ 'aria-current': false })
            new Helpers(this.regions).removeClass('highlighted')
            new Helpers(matchingRegions).setAttributes({ 'aria-current': true })

            if (selectedRegions.length === 0 && matchingRegions !== 0) {
                changeOccured = true
            } else {
                changeOccured = selectedRegions[0].getAttribute('data-id') !== matchingRegions[0].getAttribute('data-id')
            }
        }

        return changeOccured
    }

    setTown(townCode = '') {
        const selectedTowns = Array.from(this.towns).filter(town => town.getAttribute('aria-current') === 'true')
        let changeOccured = false

        if (townCode === '') {
            // clear any selected town
            new Helpers(this.towns).setAttributes({ 'aria-current': false })
            new Helpers(this.regions).setAttributes({ 'aria-expanded': false })
            this.distanceControl.setAttribute('aria-hidden', true)

            changeOccured = selectedTowns.length > 0
        } else {
            const matchingTowns = Array.from(this.towns).filter(town => town.getAttribute('data-value').toLowerCase() === townCode.toLowerCase())

            new Helpers(this.towns).setAttributes({ 'aria-current': false })
            new Helpers(matchingTowns).setAttributes({ 'aria-current': true })

            this.distanceControl.setAttribute('aria-hidden', matchingTowns.length === 0)

            if (selectedTowns.length === 0 && matchingTowns.length !== 0) {
                changeOccured = true
            } else {
                changeOccured = selectedTowns[0].getAttribute('data-id') !== matchingTowns[0].getAttribute('data-id')
            }
        }

        return changeOccured
    }

    getTown() {
        const selectedTowns = Array.from(this.towns).filter(town => town.getAttribute('aria-current') === 'true')
        if (selectedTowns.length === 0) {
            return ''
        }

        return selectedTowns[0].getAttribute('data-value')
    }
    getTownRegion() {
        const selectedTowns = Array.from(this.towns).filter(town => town.getAttribute('aria-current') === 'true')
        if (selectedTowns.length === 0) {
            return ''
        }

        return selectedTowns[0].getAttribute('data-region')
    }

    getTownTitle() {
        const selectedTowns = Array.from(this.towns).filter(town => town.getAttribute('aria-current') === 'true')
        if (selectedTowns.length === 0) {
            return ''
        }

        return selectedTowns[0].getAttribute('data-title')
    }

    getTownDefaultDistance() {
        const values = {}
        const selectedTowns = Array.from(this.towns).filter(town => town.getAttribute('aria-current') === 'true')
        if (selectedTowns.length > 0) {
            values.dd = selectedTowns[0].getAttribute('data-distance')
            return values
        }

        values.dd = 5
        return values
    }

    getValues() {
        const values = {}
        values.rgn = this.getRegion()
        values.nlc = this.getTown()
        values.nlm = this.townDistance.value

        return values
    }

    getNonDefaultValues() {
        const values = this.getValues()
        const defaultDistance = this.getTownDefaultDistance()

        if (values.nlc === '') {
            delete values.nlc
            delete values.nlm
        }

        if (values.nlm === defaultDistance.dd) {
            delete values.nlm
        }

        return values
    }

    setValues(values, url) {
        if (typeof values.rgn !== 'undefined') {
            this.setRegion(values.rgn)
        } else {
            const code = this.getRegionCodeForUrl(url)
            this.setRegion(code)
        }

        if (typeof values.nlc !== 'undefined') {
            this.setTown(values.nlc)

            const distance = values.nlm || this.getTownDefaultDistance().dd
            if (this.townDistance.value !== distance) {
                this.townDistance.value = distance
                this.townDistance.dispatchEvent(new CustomEvent('sync'))
            }
        } else {
            this.setTown('')
        }
        this.toggleRegionExpanders(true)
        this.updateMap()
    }

    setRegionCounts(regions) {
        Array.from(this.regions).forEach((region) => {
            const code = region.getAttribute('data-value')
            const count = regions.getAttribute(code.toLowerCase())
            const el = region.getElementsByTagName('a')[0].getElementsByTagName('span')[0]
            el.innerHTML = count
        })
    }


    toggleRegionExpanders(expandRegion = false, setTownInView = false) {
        const values = this.getValues()
        let parents = []
        let activeRegion = null
        let activeRegionExpanded = false
        let town = null
        let townsList = null
        let townIsFeatured = false

        if (values.nlc !== null && values.nlc !== '') {
            const matchingTowns = Array.from(this.towns).filter(t => t.getAttribute('data-value') === values.nlc)
            if (matchingTowns.length > 0) {
                // get the containing list
                townsList = new Helpers(matchingTowns[0]).getClosest('.location-towns')
                // set whether the selected town is a "featured town" this can be infered
                // by the number of records matched on the matchingTowns value
                townIsFeatured = matchingTowns.length === 2
                // set town to the currently visible town
                town = townIsFeatured && townsList.getAttribute('aria-expanded') === 'true' ? matchingTowns[1] : matchingTowns[0]
                activeRegion = town
            }
        } else {
            activeRegion = Array.from(this.regions).find(region => region.getAttribute('aria-current') === 'true')
            activeRegionExpanded = activeRegion.getAttribute('aria-expanded') === 'true'
        }

        // reset view, collapse everything
        new Helpers(this.regions).setAttributes({ 'aria-expanded': false })

        if (town !== null) {
            let parentUL = new Helpers(activeRegion).getClosest('ul')
            parents = new Helpers(parentUL).getParents(parentUL, '.location')
        } else {
            parents = new Helpers(activeRegion).getParents(activeRegion, '.location')
        }
        this.HighlightParents(activeRegion.getAttribute('data-parent-id'))
        //parents.forEach((item) => {
        //    let parentItem = new Helpers(item)
        //    parentItem.addClass('highlighted')
        //    item.setAttribute('aria-expanded', true)
        //})

        var fixedRegions = document.getElementsByClassName('location-region--fixed')
        Array.from(fixedRegions).forEach((item) => {
            item.setAttribute('aria-expanded', true)
        })

        if (activeRegion !== null) activeRegion.setAttribute('aria-expanded', expandRegion || !activeRegionExpanded)
        if (townsList !== null && typeof (townsList) !== 'undefined' && townIsFeatured === false) townsList.setAttribute('aria-expanded', true)
        if (setTownInView && town !== null) {
            document.getElementsByClassName('results-aside__locations')[0].scrollTop = town.offsetTop
        }
    }
    HighlightParents(parentId) {
        if (parentId !== '') {
            var parentItem = document.querySelector('.location[data-id="' + parentId + '"]')
            if (typeof parentItem !== 'undefined' && parentItem !== null) {
                new Helpers(parentItem).addClass('highlighted')
                var newParentID = parentItem.getAttribute("data-parent-id")
                parentItem.setAttribute('aria-expanded', true)
                if (newParentID > 0) {
                    this.HighlightParents(newParentID);
                }
            } 
        }
    }
    initMap() {
        if (this.map === null) {
            this.map = new Map(this.mapElement.id, {
                coords: [50.1016, -5.2750],
                zoom: 9,
                minZoom: 4,
                maxZoom: 14,
                zoomControl: false,
                attributionControl: false,
                dragging: false,
                doubleClickZoom: false,
                scrollWheelZoom: false,
            }, {
                LocationMap: streetLayer(),
            })
        }
    }

    updateMap() {
        // location map no longer visible
        // chosing to leave code in place as this descision may be reversed
        if (true) return


        this.initMap()
        this.map.map.invalidateSize()
        const values = this.getValues()

        if (this.activeGeoFetch !== -1) {
            this.activeGeoFetch.getXHR().abort()
        }

        this.activeGeoFetch = new XHRPromise()
        this.activeGeoFetch.send({
            url: `/feeds/geography.aspx?regionCode=${values.rgn}&locationCode=${values.nlc}&distance=${values.nlm}`,
        })
            .then((response) => {
                return (new window.DOMParser()).parseFromString(response.responseText, 'text/xml')
            })
            .then((data) => {
                const location = data.getElementsByTagName('location')
                if (location.length > 0) {
                    const wkt = location[0].getAttribute('wkt')
                    this.map
                        .clearShapes()
                        .addShape(wkt, { color: '#29abe3' })
                        .fitShapes()
                }

                this.activeGeoFetch = -1
            }).catch((error) => {
                if (error.reason !== 'abort') {
                    console.log(error)
                }
            })
    }

    resultsHighlight(direction) {
        const currentHighlight = this.searchResults.querySelector('li[aria-current="true"]')
        let newHighlight = null

        if (direction === 1) {
            if (currentHighlight === null || currentHighlight.nextElementSibling === null) {
                newHighlight = this.searchResults.firstElementChild
            } else {
                newHighlight = currentHighlight.nextElementSibling
            }
        } else {
            if (currentHighlight === null || currentHighlight.previousElementSibling === null) {
                newHighlight = this.searchResults.lastElementChild
            } else {
                newHighlight = currentHighlight.previousElementSibling
            }
        }

        if (currentHighlight !== null) {
            currentHighlight.setAttribute('aria-current', false)
        }

        if (newHighlight !== null) {
            newHighlight.setAttribute('aria-current', true)
        }

    }

    resultsTrigger() {
        const currentHighlight = this.searchResults.querySelector('li[aria-current="true"]')
        if (currentHighlight !== null) {
            currentHighlight.click()
        }
    }

    locationSearch() {
        const searchTerm = this.search.value
        const container = document.getElementsByClassName('results-aside__location-search')
        const activeClass = 'results-aside__location-search--active'

        if (this.activeSearchFetch !== -1) {
            this.activeSearchFetch.getXHR().abort()
        }


        if (searchTerm.length >= 3 || (searchTerm.length >= 1 && !isNaN(searchTerm))) {

            this.activeSearchFetch = new XHRPromise()

            this.activeSearchFetch.send({
                url: `/feeds/geoSearch.aspx?s=${searchTerm}`
            }).then((results) => {
                this.searchResults.innerHTML = ''
                results.responseText.forEach((r) => {
                    const resultItem = document.createElement('li')
                    if (r.Place.length > 0) {
                        resultItem.innerHTML = `<em>${r.Name}</em><span>${r.Place}</span>`
                    } else {
                        resultItem.innerHTML = `<em>${r.Name}</em>`
                    }
                    resultItem.setAttribute('data-value', r.Name)
                    resultItem.setAttribute('data-type', r.Type)
                    resultItem.setAttribute('data-code', r.Code)
                    resultItem.setAttribute('data-point', r.Point.join(','))
                    resultItem.setAttribute('data-url', r.Url)
                    this.searchResults.appendChild(resultItem)
                })

                if (results.responseText.length > 0) {
                    new Reveal(container).show(activeClass)
                    if (results.responseText.length === 1) {
                        this.resultsHighlight(1)
                    }
                } else {
                    new Reveal(container).hide(activeClass)
                    // no results for this term, log it as a GA event
                    clearTimeout(this.noMatchTimeout)
                    this.noMatchTimeout = setTimeout(() => {
                        window.dataLayerQueue = window.dataLayerQueue || []
                        window.dataLayerQueue.push({ event: 'resultsLocationSearch', searchTerm: searchTerm })
                    }, 1000)
                }
                this.activeSearchFetch = -1
            }).catch((error) => {
                if (error.reason !== 'abort') {
                    console.log(error)
                }
            })
        } else {
            new Reveal(container).hide(activeClass)
        }
    }

    hideLocationSearchResults() {
        const container = document.getElementsByClassName('results-aside__location-search')
        const activeClass = 'results-aside__location-search--active'

        this.searchResults.innerHTML = ''
        new Reveal(container).hide(activeClass)
    }
}

export default ResultsLocation
